import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4075e0ef"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "loan-dialog-wrap"
};
const _hoisted_2 = {
  class: "loan-dialog-header flex-items-center flex-row-space-between"
};
const _hoisted_3 = {
  key: 0,
  class: "steth-tip-text"
};
const _hoisted_4 = {
  class: "loan-dialog-content"
};
const _hoisted_5 = {
  class: "flex-row-space-between"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "value"
};
const _hoisted_8 = {
  key: 0,
  class: "flex-row-space-between"
};
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  class: "value"
};
const _hoisted_11 = {
  key: 1,
  class: "flex-row-space-between"
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  class: "value"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "dlg-liner"
}, null, -1));
const _hoisted_15 = {
  class: "flex-row-space-between"
};
const _hoisted_16 = {
  class: "title"
};
const _hoisted_17 = {
  class: "value"
};
const _hoisted_18 = {
  class: "flex-row-space-between"
};
const _hoisted_19 = {
  class: "title"
};
const _hoisted_20 = {
  class: "value"
};
const _hoisted_21 = {
  class: "flex-row-space-between"
};
const _hoisted_22 = {
  class: "title"
};
const _hoisted_23 = {
  class: "value"
};
const _hoisted_24 = {
  key: 2,
  class: "flex-row-space-between"
};
const _hoisted_25 = {
  class: "title"
};
const _hoisted_26 = {
  class: "value"
};
const _hoisted_27 = {
  class: "account-tip"
};
const _hoisted_28 = {
  key: 0,
  class: "leverage-lt-tip flex-row"
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  class: "agreement flex-row-items-center"
};
const _hoisted_31 = ["innerHTML"];
const _hoisted_32 = {
  key: 1,
  class: "agreement-tip"
};
const _hoisted_33 = {
  class: "loan-dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_close = _resolveComponent("close");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_kyc_dialog = _resolveComponent("kyc-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    "model-value": $props.visible,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    center: true,
    "show-close": false,
    width: "440px",
    top: "20vh"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("h4", null, _toDisplayString($setup.t('loan_confirm_order')), 1), _createVNode(_component_el_icon, {
      class: _normalizeClass(["close-icon ts", {
        'disabled': _ctx.loading
      }]),
      onClick: _ctx.handleDialogCancel
    }, {
      default: _withCtx(() => [_createVNode(_component_close)]),
      _: 1
    }, 8, ["class", "onClick"])]), $setup.showStethTip ? (_openBlock(), _createElementBlock("p", _hoisted_3, " * " + _toDisplayString($setup.t('stethTradeTipText')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("ul", null, [_createElementVNode("li", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString($setup.t('loan_confirm_amount')), 1), _createElementVNode("span", _hoisted_7, _toDisplayString($setup.toFormat($props.data.loanamount, $props.data.loanPrecision)) + " " + _toDisplayString($props.data.loanTokenName), 1)]), $props.data?.periodType !== 2 ? (_openBlock(), _createElementBlock("li", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString($setup.t('loan_total_interest_new')), 1), _createElementVNode("span", _hoisted_10, _toDisplayString($setup.toFormat($props.data.totalInterest, $props.data.interestPrecision, 0)) + " " + _toDisplayString($props.data.loanTokenName), 1)])) : _createCommentVNode("", true), $props.data?.periodType !== 2 ? (_openBlock(), _createElementBlock("li", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString($setup.t('loan_total_repayment_new')), 1), _createElementVNode("span", _hoisted_13, _toDisplayString($setup.toFormat($props.data.totalAmount, $props.data.interestPrecision, 0)) + " " + _toDisplayString($props.data.loanTokenName), 1)])) : _createCommentVNode("", true), _hoisted_14, _createElementVNode("li", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString($setup.t('loan_pledge_amount')), 1), _createElementVNode("span", _hoisted_17, _toDisplayString($setup.toFormat($props.data.pledgeamount, $props.data.pledgePrecision)) + " " + _toDisplayString($props.data.pledgeTokenName), 1)]), _createElementVNode("li", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString($setup.t('yearlyInterestRateNew')), 1), _createElementVNode("span", _hoisted_20, _toDisplayString($setup.truncateDecimal($setup.times($props.data.dayInterestRate, 100 * 365), 2)) + "% ", 1)]), _createElementVNode("li", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString($setup.t('loan_limit')), 1), _createElementVNode("span", _hoisted_23, _toDisplayString($props.data?.periodType === 2 ? $setup.t('otcFlexible') : $setup.t('loan_limit_day', {
      num: $props.data.limit
    })), 1)]), $props.data?.periodType !== 2 ? (_openBlock(), _createElementBlock("li", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString($setup.t('loan_repay_time_new')), 1), _createElementVNode("span", _hoisted_26, _toDisplayString($setup.formatLocalTime($props.data.repayTime)), 1)])) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_27, " * " + _toDisplayString($setup.t('loan_assets_transfer_layer', {
      account: $props.data?.targetAccountType === 1 ? $setup.t('loan_spot_account') : $props.data?.targetAccountType === 5 ? $setup.t('funding') : $setup.t('unifiedAccount')
    })), 1), !!$setup.userInfo.isMSUser ? (_openBlock(), _createElementBlock("p", _hoisted_28, [!!$setup.userInfo.isMSUser ? (_openBlock(), _createElementBlock("span", _hoisted_29, "* " + _toDisplayString($setup.t('loan_lt_user_tip')), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_el_checkbox, {
      modelValue: $setup.isAgreement,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.isAgreement = $event)
    }, null, 8, ["modelValue"]), _createElementVNode("p", {
      class: "ar-sa",
      innerHTML: $setup.t('loan_agreement', {
        url: $setup.noDmainUrl($setup.replace('/help-center/bybitHC_Article?id=000001772'))
      })
    }, null, 8, _hoisted_31)]), !$setup.isAgreement ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString($setup.t('loanSureTips')), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_33, [_createVNode(_component_el_button, {
      class: _normalizeClass(["flex-1 confirm", {
        'loading': _ctx.loading
      }]),
      type: "main",
      loading: _ctx.loading,
      disabled: !$setup.isAgreement,
      onClick: _ctx.handleDialogConfirm
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.t('confirm')), 1)]),
      _: 1
    }, 8, ["class", "loading", "disabled", "onClick"])])]),
    _: 1
  }, 8, ["model-value"])]), _createVNode(_component_kyc_dialog, {
    visible: $setup.checkUser.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = $event => $setup.checkUser.visible = $event),
    content: $setup.checkUser.content,
    type: $setup.checkUser.type,
    "confirm-text": $setup.checkUser.confirmText
  }, null, 8, ["visible", "content", "type", "confirm-text"])], 64);
}